// extracted by mini-css-extract-plugin
export default {"searchBoxPrefix":"AllInstructorPage_searchBoxPrefix__-0LHP","option":"AllInstructorPage_option__44oyG","active":"AllInstructorPage_active__S5vRI"};